// Khai DỮ LIỆU (không phải logic) cho cả 3 bộ "Xuất/Nhập hàng loạt" - đối xứng với BE
// config/family_book_import_export.php (key phải khớp NHAU giữa 2 phía). Thêm 1 loại MỚI ở FE chỉ
// cần thêm 1 phần tử ở đây - FamilyBookImportExportPage.js đọc config này để tự đổi UI bước Xuất
// (cần chọn gì trước khi xuất) mà không cần viết thêm 1 trang riêng.
//
// exportMode:
//   'blank'            - không cần chọn gì (đang TẠO MỚI, chưa có gì để chọn) - chỉ hỏi số dòng
//                         trống muốn tạo.
//   'pick_family_book'  - cần tìm & chọn 1/nhiều SỔ trước khi xuất (chỉ sổ org trực tiếp sở hữu).
//   'pick_member'       - cần tìm & chọn 1/nhiều THÀNH VIÊN trước khi xuất.
export const IMPORT_EXPORT_ENTITIES = {
    family_book: {
        key: 'family_book',
        label: 'family book bulk entity label',
        exportMode: 'blank',
    },
    family_book_member: {
        key: 'family_book_member',
        label: 'family book member bulk entity label',
        exportMode: 'pick_family_book',
    },
    sacrament: {
        key: 'sacrament',
        label: 'sacrament bulk entity label',
        exportMode: 'pick_member',
        // Loại này cần thêm 1 lựa chọn phụ trước khi xuất (loại bí tích mặc định điền sẵn mọi dòng) -
        // các loại khác không cần, để trống/undefined là đủ.
        needsSacramentTypeSelect: true,
    },
}

export const IMPORT_EXPORT_ENTITY_ORDER = ['family_book', 'family_book_member', 'sacrament']
